module.exports = __webpack_public_path__ + "static/document-4aca9767d30f77741e062ce037d5bd3f.jpg";